import { api } from '@/lib/api'
import type { Announcement, AnnouncementDraftPayload, AnnouncementForUser } from './types'

export const announcementsApi = {
  // Platform-admin
  adminList: () =>
    api.get<{ announcements: Announcement[] }>('/api/admin/announcements'),
  adminGet: (id: number) =>
    api.get<{ announcement: Announcement }>(`/api/admin/announcements/${id}`),
  adminCreateDraft: (body: AnnouncementDraftPayload) =>
    api.post<{ announcement: Announcement }>('/api/admin/announcements', body),
  adminUpdateDraft: (id: number, body: Partial<AnnouncementDraftPayload>) =>
    api.patch<{ announcement: Announcement }>(`/api/admin/announcements/${id}`, body),
  adminDeleteDraft: (id: number) =>
    api.del<{ ok: true }>(`/api/admin/announcements/${id}`),
  adminPublish: (id: number) =>
    api.post<{ announcement: Announcement }>(`/api/admin/announcements/${id}/publish`, {}),

  // Customer-side (read-only)
  userList: () =>
    api.get<{ announcements: AnnouncementForUser[] }>('/api/announcements'),
  userUnreadCount: () =>
    api.get<{ count: number }>('/api/announcements/unread-count'),
  userMarkRead: (id: number) =>
    api.post<{ ok: true }>(`/api/announcements/${id}/read`, {}),
}
